import styled from "styled-components";

import { CompanyProfileLinkFragment } from "@otta/search/schema";
import { breakpoints } from "@otta/design-tokens";

const Picture = styled.picture`
  display: flex;
`;

const Image = styled.img`
  object-fit: cover;
  max-width: 100%;
  flex: 1 1 0;
`;

export function Asset({
  className,
  asset: ba,
}: {
  className?: string;
  asset: CompanyProfileLinkFragment;
}): React.ReactElement | null {
  return ba.mobilePlacement ? (
    <Picture key={ba.id} className={className}>
      {!!ba.desktopPlacement && (
        <source
          media={`(min-width: ${breakpoints.tablet}px)`}
          srcSet={ba.desktopPlacement?.sourceSet ?? undefined}
          src={ba.desktopPlacement?.source ?? undefined}
        />
      )}

      <Image
        srcSet={ba.mobilePlacement.sourceSet ?? undefined}
        src={ba.mobilePlacement.source ?? undefined}
        alt={ba.companyBrandAsset.alt ?? undefined}
      />
    </Picture>
  ) : null;
}
